import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui';
import { useState, useEffect, ChangeEvent } from 'react';
import { useModalStore } from '@/store/use-modal-store';
import { useUnifiedAccount } from '@/hooks';
import mobileConnectIcon from '@/assets/icons/connect-mobile-icon.svg';
import Loader from '@/components/ui/loader';
import { useRegisterUser } from '@/lib/api/register-user';
import { ErrorCode, ErrorMsgs, ErrorResponse } from '@/types';
import { toast } from 'sonner';
import { MonitorSmartphone } from 'lucide-react';

interface MobileConnectionDialogProps {
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  displayTrigger?: boolean;
}

export const MobileConnectionDialog = ({
  isOpen: externalIsOpen,
  onOpenChange = () => {},
  displayTrigger = true,
}: MobileConnectionDialogProps) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isControlled = externalIsOpen !== undefined;
  const isOpen = isControlled ? externalIsOpen : internalIsOpen;

  const { handleSwitchModalOpen, handleQrCodeModalOpen } = useModalStore();

  useEffect(() => {
    if (isControlled) {
      setInternalIsOpen(externalIsOpen);
    }
  }, [externalIsOpen, isControlled]);

  const { isWrongAddress, address } = useUnifiedAccount();

  const handleOpenChange = (newIsOpen: boolean) => {
    if (isWrongAddress) {
      handleSwitchModalOpen(true);
      return;
    }
    if (!isControlled) {
      setInternalIsOpen(newIsOpen);
    }
    onOpenChange?.(newIsOpen);
  };

  const { mutateAsync: registerUser, isPending: isRegistering } =
    useRegisterUser();

  const handleRegister = async () => {
    if (address) {
      try {
        await registerUser({ address, rememberMe: true, isMobile: true });

        setInternalIsOpen(false);
        handleQrCodeModalOpen(true);
      } catch (error: any) {
        console.error(error);

        const code: ErrorCode =
          (error as any)?.response?.data?.detail?.code || null;

        if (code && code in ErrorMsgs) {
          toast.error(`Mobile Connection Approval failed - ${ErrorMsgs[code]}`);
        } else if ('code' in error && error.code === 4001) {
          toast.error('User rejected the request');
        }
        setInternalIsOpen(false);
      }
    } else {
      toast.error('Please connect your wallet first');
    }
  };

  useEffect(() => {
    if (isOpen) handleRegister();
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      {displayTrigger && (
        <DialogTrigger>
          {/* <img
            src={mobileConnectIcon}
            alt="Mobile Connection"
            className="cursor-pointer hover:opacity-80"
          /> */}
          <MonitorSmartphone size={18} className="text-primary" />
          {/* <Button size="icon" className="rounded-none">
          </Button> */}
        </DialogTrigger>
      )}
      <DialogContent className="gap-0 border border-border bg-background p-0 sm:max-w-md sm:rounded-none">
        <DialogHeader className="px-5 pt-6"></DialogHeader>
        <div className="flex flex-col items-center gap-3 px-5 pb-10 pt-6">
          <Loader className="w-20 py-5" />
          <p className="text-lg">Approve QR code with wallet...</p>
        </div>
        <DialogFooter className="sm:flex-col sm:gap-0 sm:space-x-0">
          {/* <Button
            type="button"
            onClick={handleRegister}
            className="h-14 w-full rounded-none font-mono text-lg font-normal tracking-wider"
            disabled={isRegistering}
          >
            {isRegistering ? 'CONFIRM IN WALLET' : 'SIGN MESSAGE'}
          </Button> */}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
